export default {
  init() {

  },
  finalize() {
    $('.toggle-strands').on('click', function() {
      $(this).parent().toggleClass('show');
    });

    projectsAnimation();

    $(window).on('scroll', function() {
      projectsAnimation();
    });
    
    function projectsAnimation() {
      if (($(window).scrollTop() + $(window).height() - $('.projects-row').offset().top) >= 400) {
        $('.projects-row .projects-col').addClass('show');
      }
    }

    // Scroll to projects automatically if one is selected
    const $projectsAnchor = $('a[name="projects-anchor"]');

    if ($projectsAnchor.length > 0) {
      window.scrollTo(0, $projectsAnchor.offset().top - 20);
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateProjectListing.js